/**
 * common.js — Sage 9 route, runs on every page.
 *
 * init()     : sets up globals and utilities that other modules depend on.
 * finalize() : wires up all UI, AJAX, and event handlers.
 *
 * Add new site-wide behaviour by creating a module in ./common/ and wiring
 * it in below — don't add logic directly to this file.
 */

// ─── Shared utilities (also exposed on window) ───────────────────────────────
import { initViewportUtils } from '../utils/viewport';
import { initUrlUtils }      from '../utils/url';

// ─── init() modules ──────────────────────────────────────────────────────────
import { initAjax }         from './common/ajax';
import { initResize }       from './common/resize';

// ─── finalize() modules ───────────────────────────────────────────────────────
import { initHeader }       from './common/header';
import { initPrimeCore }    from './common/prime-core';
import { initPrimeFilters } from './common/prime-filters';
import { initMatchesImage } from './common/prime-matches-image';
import { initFrontpage }    from './common/frontpage';
import { initUI }           from './common/ui';

export default {
    init() {
        // Utilities first — viewport globals must exist before any scroll/resize handlers
        initViewportUtils();
        initUrlUtils();

        // Ajax object and window.sTheLoader must exist before finalize() fires
        initAjax();

        // Seeds iTheWidth / iTheHeight and attaches resize listener
        initResize();
    },

    finalize() {
        // Header scroll behaviour reads window.disableHeaderAnim (set here)
        initHeader();

        // Prime AJAX core: initial .prime-data.v2 load, triggerAjax, postProcessPrimeData
        initPrimeCore();

        // All filter selects, load-more, datepickers, stats search button
        initPrimeFilters();

        // Matches image template: season/tournament/team selects + generate button
        initMatchesImage();

        // Frontpage article loader + news selector
        initFrontpage();

        // All remaining UI event handlers
        initUI();
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js